import { render, staticRenderFns } from "./kost_detail.vue?vue&type=template&id=de1f0150&scoped=true&"
import script from "./kost_detail.vue?vue&type=script&lang=js&"
export * from "./kost_detail.vue?vue&type=script&lang=js&"
import style0 from "./kost_detail.vue?vue&type=style&index=0&id=de1f0150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1f0150",
  null
  
)

export default component.exports